import React, {Dispatch, MouseEvent, SetStateAction} from 'react';

/**
 * Get an object that can be spread for use in Bootstrap forms, like
 * `<FormControl {...withFormControl(state)}/>`.
 */
export function withFormControl<T>(state: {value: T; setValue: Dispatch<SetStateAction<T>>}) {
  // See https://github.com/react-bootstrap/react-bootstrap/issues/2781
  function onChange(event: React.FormEvent<any>) {
    const target = event.currentTarget;
    state.setValue(typeof state.value === 'number' ? (+target.value as any) : target.value);
  }

  // FormControl expects a string for value
  return {value: '' + state.value, onChange};
}

/**
 * Remove focus from a clicked element, and remove any `active` class to hide
 * tooltips.
 *
 * Removing focus kills keyboard navigation. Also, on touch devices that emulate
 * `:hover`, the element may still be stuck in some active state after touch.
 */
export function blur(e: MouseEvent) {
  // We need `currentTarget` rather than `target`, to support clicking the
  // icon in the button, in which case the button is not the (first) target
  (e.currentTarget as HTMLElement).blur();
  (e.currentTarget as HTMLElement).classList.remove('active');
}
